import { FC } from 'react';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import styles from './ServiceNameSection.module.scss';

interface ServiceNameSectionProps {
    className?: string;
    value: string;
    error: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ServiceNameSection: FC<ServiceNameSectionProps> = ({ value, error, onChange, className }) => {
    return (
        <Input
            label="Service Name"
            placeholder="Ex. Furry Friends Pet Care"
            required={true}
            error={error}
            value={value}
            onChange={onChange}
            className={className}
        />
    );
};
